import React, { Component } from 'react'
import { PropTypes } from 'prop-types'
import { connect } from 'react-redux'
import {
  startProcess,
  getNextStep,
  getPrevStep,
  acknowledgeContract,
  toggleLoginForm,
  authenticated,
  unauthenticated
} from '../../state/actions/stepActions'

import { getPartnershipAndConventionFromRawValue,posProducts,scrollToFirstInvalidComponent } from '../../utils'

import Page from '../../components/page'
import Flowbar from '../../components/flowbar'
import Header from '../../components/header'
import Wrapper from '../../components/wrapper'
import Clearfix from '../../components/clearfix'
import Title from '../../components/title'
import Widgets from '../../components/widgets'
import Button from '../../components/button'
import Footer from '../../components/footer'
import Spinner from '../../components/spinner'
import Modal from '../../components/modal'
import AuthModal from '../../components/authmodal'
// import AddressModal from '../../components/addressmodal'
import WebcamModal from '../../components/webcammodal'
import Result from '../../components/result'
import TitolareEffictivo from '../../components/titolareEffictivo'
import { css, withStyles } from '../../styles/withStyles'
import Styles from './styles'
import { addTitolareUser } from '../../state/actions/stepActions'
import { ProgressBar } from '../../components/progressBar'
import {ios11Instructions} from '../../utils'
import {SelectPlan} from '../../components/selectPlan'
import {PlanToolbar} from '../../components/planToolbar'
import { PlanAlertPopup } from '../../components/planAlertPopup';
import { FetchPOSPlan } from '../../state/api'

class App extends Component {
  constructor(props) {
    super(props)

    this.state = {
      posplanInDB : ''
    };
  }
  urlParam(name){
    var results = new RegExp('[\?&]' + name + '=([^&#]*)').exec(window.location.href);
    if (results == null){
       return null;
    }
    else {
       return decodeURI(results[1]) || 0;
    }
}
  componentDidMount() {
    const { dispatch } = this.props
    //const {step,widgets,components}=getState()
    //const urlParams = new URLSearchParams(window.location.search);
    //const queryParam = urlParams.get('plan');
   
     const queryParam=this.urlParam('plan');
    if (Object.keys(this.props.components).length === 0) {
      if(queryParam!==null || queryParam!=='')
      {
      dispatch(
        startProcess({
          partnership: this.props.partnership,
          convention: this.props.convention,
          proof: this.props.proof,
          location: this.props.location
        })
      )
      }
    }
  }
enableNextButtonColor(nextProps){
  const { step,components } = nextProps
  let isStepFilled = true
      if(!!components && Object.getOwnPropertyNames(components).length>0)
      {
        delete step.isFormFilled
        Object.keys(components)
          .filter(c => components[c].validations && components[c].validations.isRequired)
          .forEach(k => {
            if (
              (components[k].type === 'text' ||
              (components[k].type === 'radio'  && (k==='SZ0022-SS0209_DM0850_RI0950' || k==='SZ0022-SS0209_DM0850_RI0951')) ||
              components[k].type === 'date' ||
              components[k].type === 'selectbox' || 
              components[k].type ==='checkbox' ||
              components[k].type === 'TextArea' ||
            (components[k].type ==='file' && k!=='SELFIE-SELFIE_UPLOAD')
            ) && 

              components[k].status.indexOf('hidden') < 0 &&
              !components[k].isDisabled
            ) {
              const Titolare_Effettivo_CheckBoxes = [
                'SZ0024-SS0049_DM0094_RI0500',
                'SZ0024-SS0049_DM0094_RI0501', 
                'SZ0024-SS0049_DM0534_RI0502',
                'SZ0024-SS0049_DM0534_RI0503',
                'SZ0024-SS0049_DM0525_RI0576',
                'SZ0024-SS0049_DM0525_RI0577',
            ]
            const  Ulteriori_info_CheckBoxes=[
              'SZ0022-SS0208_DM0849_RI0947',
              'SZ0022-SS0208_DM0849_RI0948',
              'SZ0022-SS0208_DM0849_RI0949'
            ]
            const Ulteriori_info_RadioButtons=[
              'SZ0022-SS0209_DM0850_RI0950',
            'SZ0022-SS0209_DM0850_RI0951']
            
               if(k === "TELEFONO_FISSO-NUMERO" && step.number === 3)
               isStepFilled = isStepFilled && !components[k].errorMessage[0];
             
                else if(step.number === 4 && (k.includes("SZ0024-SS0049_DM0094_RI0504") || k.includes("SZ0024-SS0049_DM0094_RI0505") || k.includes("SZ0023-SS0048_DM0089_RI0")) )
                {  
                  if(!!components["SZ0024-SS0049_DM0094_RI0504"] && !!components["SZ0024-SS0049_DM0094_RI0505"])
                  {             
                    let holdersCheckbox = (
                      components["SZ0023-SS0048_DM0089_RI0121"].value ||
                      components["SZ0023-SS0048_DM0089_RI0607"].value ||   //Add validations for Questions begin - end
                      components["SZ0023-SS0048_DM0089_RI0123"].value ||
                      components["SZ0023-SS0048_DM0089_RI0124"].value ||
                      components["SZ0023-SS0048_DM0089_RI0125"].value ||
                      components["SZ0023-SS0048_DM0089_RI0126"].value ||
                      components["SZ0023-SS0048_DM0089_RI0381"].value
                    )
                    &&
                    (
                      !!components["SZ0024-SS0049_DM0094_RI0504"] && components["SZ0024-SS0049_DM0094_RI0504"].value || 
                      !!components["SZ0024-SS0049_DM0094_RI0505"] && components["SZ0024-SS0049_DM0094_RI0505"].value
                    );                   
                    isStepFilled = isStepFilled && !components[k].errorMessage[0] && holdersCheckbox
                  }
                  else {
                    let holdersCheckbox1 = (
                      components["SZ0023-SS0048_DM0089_RI0121"].value ||
                      components["SZ0023-SS0048_DM0089_RI0607"].value ||   //Add validations for Questions begin - end
                      components["SZ0023-SS0048_DM0089_RI0123"].value ||
                      components["SZ0023-SS0048_DM0089_RI0124"].value ||
                      components["SZ0023-SS0048_DM0089_RI0125"].value ||
                      components["SZ0023-SS0048_DM0089_RI0126"].value ||
                      components["SZ0023-SS0048_DM0089_RI0381"].value
                    )
                    isStepFilled = isStepFilled && !components[k].errorMessage[0] && holdersCheckbox1
                  }
                  }
                  else if(step.number===4 && Titolare_Effettivo_CheckBoxes.indexOf(k)>-1)
                  {
                    let isCheckBoxesGR1filled = (
                      components["SZ0024-SS0049_DM0094_RI0500"].value ||
                      components["SZ0024-SS0049_DM0094_RI0501"].value )
                      let isCheckBoxesGR2filled = (
                      components["SZ0024-SS0049_DM0534_RI0502"].value ||
                      components["SZ0024-SS0049_DM0534_RI0503"].value )
                      let isCheckBoxesGR3filled = (
                      components["SZ0024-SS0049_DM0525_RI0576"].value ||
                      components["SZ0024-SS0049_DM0525_RI0577"].value 
                    )
                    isStepFilled = isStepFilled && !components[k].errorMessage[0] && isCheckBoxesGR1filled && isCheckBoxesGR2filled && isCheckBoxesGR3filled
                  }
                  else if(step.number === 4 && Ulteriori_info_CheckBoxes.indexOf(k)>-1)
                  {
                        let ulteriinfoCheckbox=components["SZ0022-SS0208_DM0849_RI0947"].value ||
                        components["SZ0022-SS0208_DM0849_RI0948"].value ||   
                        components["SZ0022-SS0208_DM0849_RI0949"].value
                        isStepFilled = isStepFilled && !components[k].errorMessage[0] && ulteriinfoCheckbox
                  }
                  else if(step.number === 4 && Ulteriori_info_RadioButtons.indexOf(k)>-1)
                  {
                    let ulteriinfoRadios=components["SZ0022-SS0209_DM0850_RI0950"].value ||
                        components["SZ0022-SS0209_DM0850_RI0951"].value
                        isStepFilled = isStepFilled && !components[k].errorMessage[0] && ulteriinfoRadios
                  }
                else
                  isStepFilled = isStepFilled && !!components[k].value && !components[k].errorMessage[0];

                  if(step.number===3 && this.props.product.prodCode===posProducts.prodPersonaFisica && (!!components["PROFESSIONE_ATTIVITA-PROFESSIONE"] && components["PROFESSIONE_ATTIVITA-PROFESSIONE"].value!=='') && (k==="PROFESSIONE_ATTIVITA-ATTIVITA" || k==="PROFESSIONE_ATTIVITA-SETTORE"))
                  {
                    if(components[k].value==='')
                    {
                    isStepFilled = isStepFilled && components["PROFESSIONE_ATTIVITA-ATTIVITA"].values.length===0 || components["PROFESSIONE_ATTIVITA-SETTORE"].values.length===0
                    }
                  }

            }
          })
          if(isStepFilled)
          {
            step.isFormFilled=true
          }
      }
}

fetchPOSPlan = (guid) => {
  let url = 'OnboardRequestDetails/FetchPOSPlan';
  let body = { GUID: guid };
  this.setState({ posplanInDB: '' });
  FetchPOSPlan(url, body).then(json => {
      const posplanInDB = json && json.payLoad && json.payLoad.Plan && json.payLoad.Plan.toLowerCase();
      this.setState({ posplanInDB });
  })
}

  componentWillReceiveProps(nextProps) {
    const { dispatch } = this.props
    const { number } = this.props.step
    const { step, components } = nextProps

    this.enableNextButtonColor(nextProps)
    
    if (
      number === 1 &&
      !!step.auth &&
      !!step.auth.tokenId &&
      !!step.loginFormVisible
    ) {
      dispatch(getNextStep(this.props.proof))
      dispatch(authenticated())
    }

    if (
      number === 1 &&
      !!step.auth &&
      !!step.auth.tokenId &&
      step.hasServerErrors &&
      step.serverErrorStatus === 'unauthorized'
    ) {
      dispatch(unauthenticated())
      dispatch(toggleLoginForm(true))
    }

    const { step: oldStep } = this.props;
    const { guid: oldGuid } = oldStep || {};
    const { guid: newGuid } = step
    if(oldGuid!==newGuid) {
      this.fetchPOSPlan(newGuid);
    }
  }

  goBack() {
    const { dispatch } = this.props
    dispatch(getPrevStep(this.props.proof))
    // window.scrollTo(0, 0)
  }

  goForward() {
    const { dispatch, components} = this.props
    const { last } = this.props.step

    if (!!last) {
      dispatch(
        acknowledgeContract(
          this.props.components['TERMINA_PROCEDURA-CONTRATTO']
        )
      )
    } else {
      
      //@hack for CF login
      // if (
      //   number === 1 &&
      //   !!this.props.components['CODICE_FISCALE-CF'] &&
      //   !!this.props.components['CODICE_FISCALE-CF'].loginRequired
      // ) {
      //   let isStepFilled = true

      //   Object.keys(components)
      //     .filter(c => c.validations && c.validations.isRequired)
      //     .forEach(k => {
      //       if (
      //         components[k].type === 'text' &&
      //         components[k].status.indexOf('hidden') < 0
      //       ) {
      //         isStepFilled = isStepFilled && !!components[k].value
      //       }
      //     })

      //   if (isStepFilled && (!auth || !auth.tokenId)) {
      //     dispatch(toggleLoginForm(true))
      //   } else {
      //     dispatch(getNextStep(this.props.proof))
      //   }
      // } else {
        dispatch(getNextStep(this.props.proof))
      //}

     
    }
     //window.scrollTo(0, 0)
     scrollToFirstInvalidComponent(components)
  }
  addTitolare() {
    const { dispatch } = this.props
    dispatch(addTitolareUser())
  }

  render() {
    //const urlParams = new URLSearchParams(window.location.search);
    //const queryParam = urlParams.get('plan');
     const queryPlanParam=this.urlParam('plan');
     const queryRefParam=this.urlParam('ref');
    if((queryPlanParam===null || queryPlanParam==="" || queryPlanParam===0)&& this.props.step.number===1 && (this.props.step.contactId==='' || this.props.step.contactId===null))
    {
return (
  <Page>
  <Header >
  <ProgressBar StepNumber={0} NoOfSteps={0}/>
  </Header>
  <SelectPlan
  richiestaNumero="00000000" queryPlanParam={queryPlanParam} queryRefParam={queryRefParam} pathName= {this.props.location.pathname} flatSearch= "plan=flat"
  flexSearch= "plan=flex"/>
  <Footer StepNumber="0"/>
  </Page>
  )
    }
    else
    {
    let IOS11Rules=ios11Instructions()
    if (!this.globalStylesOverrides) {
      this.globalStylesOverrides = css(this.props.styles.globals)
    }

    if (
      this.props.step.isLoading ||
      (!(
        !!this.props.components && Object.keys(this.props.components).length > 0
      ) &&
        !this.props.step.hasServerErrors)
    ) {
      return <Spinner type="global" />
    }

    if (
      this.props.step.hasServerErrors &&
      this.props.step.serverErrorStatus !== 'unauthorized'
    ) {
      return (
        <Modal>
          <Result type="error">
            <div
              dangerouslySetInnerHTML={{
                __html: this.props.step.serverErrorMessage
              }}
            />
            <div dangerouslySetInnerHTML={{ __html:IOS11Rules}} />
          </Result>
          
        </Modal>
      )
    }
    let newTitle;
       if(this.props.product.prodCode===posProducts.prodAzienda && this.props.step.number===1)
       {
        newTitle='Stai iniziando la richiesta per la categoria TUTTE LE SOCIETÁ (ad esempio: sas, ss, snc, srl, spa o sapa)'
       }
       else if(this.props.product.prodCode===posProducts.prodDittaInd && this.props.step.number===1)
       {
        newTitle ='Stai iniziando la richiesta per la categoria LIBERO PROFESSIONISTA O DITTA INDIVIDUALE'
       }
       else if(this.props.product.prodCode===posProducts.prodPersonaFisica && this.props.step.number===1)
       {
         newTitle='Stai iniziando la richiesta per la categoria BED AND BREAKFAST'
       }
    return (
      
      <Page>
        {this.props.step.loginFormVisible ? <AuthModal /> : null}
        {this.props.step.isStepLoading ? <Spinner type="step" /> : null}
        {/*this.props.step.addressComponent ? (
          <AddressModal
            key={this.props.step.addressComponent.name}
            component={this.props.step.addressComponent}
          />
        ) : null*/}
        {this.props.step.webcamComponent ? (
          <WebcamModal
            key={this.props.step.webcamComponent.name}
            component={this.props.step.webcamComponent}
          />
        ) : null}
        <Header
          whiteLabel={
            !!this.props.routing.locationBeforeTransitions.query.embedded
          }
          //plan={queryParam}
        >
        {(this.props.components["POSPLAN-PLAN"] || queryPlanParam) &&
          <PlanToolbar component={this.props.components["POSPLAN-PLAN"]} posplanInDB={this.state.posplanInDB} queryRefParam={queryRefParam} queryParam={queryPlanParam} dispatch={this.props.dispatch}/>}
        
           {this.props.widgets.FLOW_BAR ? (
            //<Flowbar widget={this.props.widgets.FLOW_BAR} />
            <ProgressBar StepNumber={!!this.props.step && this.props.step.number} NoOfSteps={!!this.props.widgets.FLOW_BAR.components && this.props.widgets.FLOW_BAR.components.length}/>
          ) : null}
          
        </Header>
       
        {!!this.props.components[`FLOW_BAR-STEP_${this.props.step.number}`] ? 
        this.props.step.number===1 ?
        (<Title
          title={newTitle}  
          contactId={this.props.step.contactId}
        />):(
          <Title
            title={
               this.props.components[`FLOW_BAR-STEP_${this.props.step.number}`]
                 .value
            }
            contactId={this.props.step.contactId}
            isLastStep = {this.props.step.last} 
          />
        ): (this.props.step.last===true?<Title
          title='Accetta i contratti'
          contactId={this.props.step.contactId}
          isLastStep = {this.props.step.last} 
        />:null)}
        {((this.state.posplanInDB && queryPlanParam && queryPlanParam.toLowerCase() !== this.state.posplanInDB)
          || (this.props.components["POSPLAN-PLAN"] && this.props.components["POSPLAN-PLAN"].value && queryPlanParam && queryPlanParam.toLowerCase() !== this.props.components["POSPLAN-PLAN"].value.toLowerCase()))
          && ( <PlanAlertPopup plan={this.state.posplanInDB || this.props.components["POSPLAN-PLAN"].value} location={this.props.location} queryRefParam={queryRefParam}/>)}
        
        {this.props.step.name === "I titolari dell'azienda" ? (
          <div>
            <TitolareEffictivo
              titolareList={this.props.step.titolareList}
              widgets={this.props.widgets}
              components={this.props.components}
            />
            <Wrapper>
              <Button
                id="bt-prev"
                text="Indietro"
                action={() => {
                  this.goBack()
                }}
                disabled={
                  this.props.step.number === 1 || !!this.props.step.last
                }
              />
              <Button
                {...css(this.props.styles.listColumn)}
                id="bt-add"
                text="Aggiungi titolare"
                action={() => {
                  this.addTitolare()
                }}
                //type="secondry"
                type={ !!this.props.components[`TITOLARE_OWNER-EFFETTIVO_SI`] && this.props.components[`TITOLARE_OWNER-EFFETTIVO_SI`].value == "selected"?"secondryEnabled":"secondry" }
                disabled={this.props.step.titolareList.length === 5}
              />
              <Button
                id="bt-next"
                text="Continua"
                action={() => {
                  this.goForward()
                }}
                //type={!!this.props.step.isFormFilled && this.props.step.isFormFilled?'primaryEnabled':'primary'}
                type={(!!this.props.step.isFormFilled && this.props.step.isFormFilled
                  && !!this.props.components['TITOLARE_OWNER-EFFETTIVO_NO']
                  && this.props.components['TITOLARE_OWNER-EFFETTIVO_NO'].value === 'selected') || (!!this.props.components["TITOLARE_DATA-EFFETTIVO_SI"] && 
                  this.props.components["TITOLARE_DATA-EFFETTIVO_SI"].value===''
                && !!this.props.components["TITOLARE_DATA-EFFETTIVO_NO"] && 
                this.props.components["TITOLARE_DATA-EFFETTIVO_NO"].value==='')  ? 'primaryEnabled' : 'primary'}
                disabled={!!this.props.widgets["TITOLARE_EFFETTIVO"] && 
                !!this.props.widgets["TITOLARE_EFFETTIVO"].status && 
                this.props.widgets["TITOLARE_EFFETTIVO"].status[0]==='ignoreValidation'?!(!!this.props.components["TITOLARE_DATA-EFFETTIVO_SI"] && 
                   this.props.components["TITOLARE_DATA-EFFETTIVO_SI"].value===''
                 && !!this.props.components["TITOLARE_DATA-EFFETTIVO_NO"] && 
                 this.props.components["TITOLARE_DATA-EFFETTIVO_NO"].value==='') && !!this.props.components['TITOLARE_OWNER-EFFETTIVO_SI']  && this.props.components['TITOLARE_OWNER-EFFETTIVO_SI'].value === 'selected':!!this.props.components['TITOLARE_OWNER-EFFETTIVO_SI']  && this.props.components['TITOLARE_OWNER-EFFETTIVO_SI'].value === 'selected'}
                pullTo="right"
              />
            </Wrapper>
          </div>
        ) : (
          <Wrapper>
            {/*{!!this.props.components[
              `FLOW_BAR-STEP_${this.props.step.number}`
            ] ? (
              <Title
                title={
                  this.props.components[
                    `FLOW_BAR-STEP_${this.props.step.number}`
                  ].value
                }
                contactId={this.props.step.contactId}
              />
            ) : null}*/}
              
            <Widgets
              widgets={this.props.widgets}
              components={this.props.components}
              guid={this.props.step.guid}
              plan={queryPlanParam}
            />
            <Button
              id="bt-prev"
              text="Indietro"
              action={() => {
                this.goBack()
              }}
              disabled={this.props.step.number === 1 || !!this.props.step.last}
              display={!!this.props.step.last && 'none'}
            />
            <Button
              id="bt-next"
              text="Continua"
              action={() => {
                this.goForward()
              }}
              type={
                !!this.props.step.last && !!this.props.step.disableButton
                  ? 'inverse'
                  : !!this.props.step.isFormFilled && this.props.step.isFormFilled?'primaryEnabled':'primary'                
                }
              pullTo="right"
              disabled={
                !!this.props.step.last && !!this.props.step.disableButton
              }
            />
            {/* {console.log(this.props)} */}
            <Clearfix />
          </Wrapper>
        )}
        <Footer plan={queryPlanParam}/>
      </Page>
    )
    }
  }
}

App.propTypes = {
  step: PropTypes.object.isRequired,
  widgets: PropTypes.object.isRequired,
  components: PropTypes.object.isRequired,
  dispatch: PropTypes.func.isRequired,
  partnership: PropTypes.string,
  convention: PropTypes.string,
  proof: PropTypes.object
}

const mapStateToProps = (state, ownProps) => {
  const deltaProps = {
    ...state,
    ...getPartnershipAndConventionFromRawValue(ownProps.params.flow),
    proof: {
      value: ownProps.location.query.proof,
      type: ownProps.location.query.proofType
    }
  }

  return deltaProps
}

export default connect(mapStateToProps)(withStyles(Styles)(App))



// WEBPACK FOOTER //
// ./containers/app/index.js